import { render, staticRenderFns } from "./panel_task.vue?vue&type=template&id=cbaf433e&scoped=true&"
import script from "./panel_task.vue?vue&type=script&lang=js&"
export * from "./panel_task.vue?vue&type=script&lang=js&"
import style0 from "./panel_task.vue?vue&type=style&index=0&id=cbaf433e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbaf433e",
  null
  
)

export default component.exports